export const handleError = (e, context) => {
  // console.log(e)
}

export default ({
  Vue
}) => {
  Vue.prototype.$handleError = handleError
}
